<div class="list-topbar">
  <p>Create roles to define permissions, then assign them to users</p>
  @if (canCreate()) {
    <button tuiButton appearance="primary" size="s" iconStart="@tui.plus" type="button" (click)="add.emit()">
      Add user
    </button>
  }
</div>

@if (isLoading()) {
  <tui-loader size="l" />
} @else if (!canList()) {
  <div tuiNotification appearance="warning">
    You do not have permission to see the users of your organization.
  </div>
} @else {
  <div class="user-cards">
    @for (user of users(); track user.id) {
      <div class="user-card">
        <div [tuiAvatar]="user.photo ? '' : '@tui.user'" size="m" [round]="true">
          @if (user.photo) {
            <img [src]="user.photo" [alt]="user.fullName" />
          }
        </div>
        <span class="user-name">{{ user.fullName }}</span>
        <span class="user-role">{{ user.role.name }}</span>
        <span tuiBadge [appearance]="user.is_active ? 'positive' : 'negative'" size="l">
          {{ user.is_active ? 'Active' : 'Inactive' }}
        </span>
        <span class="actions">
          @if (canEdit()) {
            <button
              tuiButton
              appearance="flat"
              size="s"
              iconStart="@tui.pencil"
              type="button"
              (click)="edit.emit(user.id)"
            >
              Edit
            </button>
          }
          @if (canDelete() && user.id !== currentUserId()) {
            <button
              tuiButton
              appearance="flat-destructive"
              size="s"
              iconStart="@tui.trash-2"
              type="button"
              (click)="onDelete(user)"
            >
              Delete
            </button>
          }
        </span>
      </div>
    } @empty {
      <p class="empty">No users found.</p>
    }
  </div>
}
